import React from 'react'
import { Container, Row, Col } from "react-bootstrap";
import { AiFillGithub } from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
import { motion } from "framer-motion";
import AnimatedSection from "../AnimatedSection";
import './Social.css'

const Social = () => {
  const iconVariants = {
    hover: {
      y: -5,
      scale: 1.1,
      boxShadow: "0px 10px 25px rgba(6, 182, 212, 0.4)",
      borderColor: "var(--accent-cyan)",
      color: "#ffffff"
    },
    tap: { scale: 0.95 }
  };

  return (
    <Container style={{ padding: '40px 0' }}>
      <Row>
        <Col md={12} className="contact-social">
          <AnimatedSection direction="up" delay={0.1}>
            <div className='contact-text'>
              <h1 style={{ fontFamily: "var(--font-heading)", fontWeight: "600", letterSpacing: "0.05em" }}>FIND ME ON</h1>
              <p style={{ color: "var(--text-secondary)", fontSize: "1.05rem" }}>
                Please don't hesitate to reach out to me and <strong className="yellow">connect.</strong>
              </p>
            </div>
          </AnimatedSection>
          
          <ul className="contact-social-links">
            <li className="contact-icons">
              <AnimatedSection direction="up" delay={0.2}>
                <motion.a
                  href="https://github.com/buntychakraborty"
                  target="_blank"
                  rel="noreferrer"
                  className="contact-social-icons"
                  variants={iconVariants}
                  whileHover="hover"
                  whileTap="tap"
                >
                  <AiFillGithub />
                </motion.a>
              </AnimatedSection>
            </li>
          
            <li className="contact-icons">
              <AnimatedSection direction="up" delay={0.3}>
                <motion.a
                  href="https://www.linkedin.com/in/bunty-chakraborty-b5a395119/"
                  target="_blank"
                  rel="noreferrer"
                  className="contact-social-icons"
                  variants={iconVariants}
                  whileHover="hover"
                  whileTap="tap"
                >
                  <FaLinkedinIn />
                </motion.a>
              </AnimatedSection>
            </li>
          </ul>
        </Col>
      </Row>
    </Container>
  )
}

export default Social